import { ApiService }          from '../../app-lite/api/api.service';
import { ApiModel }            from '../../app-lite/api/models/api.model';
import { JsonService }         from '../../app-lite/core/services/json.service';
import { InvoiceModel }        from '../../app-lite/invoices/models/invoice';
import { ConfirmService }      from '../../app-lite/messages/confirm/confirm.service';
import { SessionService }      from '../../app-lite/sessions/session.service';
import { TillpaymentsService } from '../../app-lite/tillpayments/tillpayments.service';

import CustomerCashPaymentHtml from '../customers/customer.cash-payment.html';

export class CashInvoiceService {
  constructor (
    private $q             : ng.IQService,
    private $state         : ng.ui.IStateService,
    private $timeout       : ng.ITimeoutService,
    private $translate     : ng.translate.ITranslateService,
    private $uibModal      : ng.ui.bootstrap.IModalService,
    private $window        : ng.IWindowService,
    private API            : ApiModel,
    private confirm        : ConfirmService,
    private sessionObjAPI  : SessionService,
    private workshopAPI    : ApiService
  ) {}

  print ( invoice : InvoiceModel, options : any ) : ng.IPromise<InvoiceModel> {
    const user    = this.sessionObjAPI.user();
    const version = this.sessionObjAPI.company().invoice_v1
      ? 'invoice'
      : ( (invoice.printType === 'C')
        ? 'jasper_cash_invoice'
        : 'jasper_invoice'
      );

    const link = options && options.isSale
      ? `${ this.API.url }/reports/jasper_unit_sale/${invoice.id}.pdf`
      : `${ this.API.url }/reports/${version}/${invoice.id}.pdf`;

    if (user.receipt_for_cash) {
      this.$window.open(link, '_blank' );
    }
    else if (user.receipt_for_cash !== false) {
      this.confirm.save(this.$translate.instant('JS_SPACE.CONFIRM.PRINT_INVOICE'))
      .then(( data : any ) => {
        if (data.remember) {
          user.receipt_for_cash = data.answer;

          this.workshopAPI.patch('/user', user, 'user')
          .finally(() => this.sessionObjAPI.refresh());
        }

        if (data.answer) {
          this.$window.open(link, '_blank' );
        }
      });
    }

    return this.$q.when(invoice);
  }

  process ( invoice : InvoiceModel , options : any ) : ng.IPromise<InvoiceModel> {
    const isRefund = invoice.invoice_type === 'C';

    return this.$uibModal.open({
      controller : 'CashPaymentCtrl',
      templateUrl: CustomerCashPaymentHtml,
      windowClass: 'lg-modal',
      resolve    : {
        customer    : () => this.workshopAPI.get('/customer', invoice.customer_id),
        integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
        invoice     : ( jsonApi : JsonService ) => {
          invoice.printType = jsonApi.parse(localStorage.getItem('invoicePrintCashSwitch')) || 'I';

          return invoice;
        },
        isRefund  : () => isRefund,
        methods   : () => this.workshopAPI.get('/invoice_payment_methods'),
        terminalId: ( tillpaymentsApi : TillpaymentsService ) : ng.IPromise<any> => tillpaymentsApi.getDefaultUserTerminalId()
      }
    }).result
    .then(( invoice : InvoiceModel ) => isRefund ? this.$q.when(invoice) : this.$timeout(() => this.print(invoice, options), 2000))
    .catch(err => {
      this.$state.reload();

      return this.$q.reject(err);
    });
  }
}
